import { Container } from './styles';
import { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { Accordion, ListGroup } from 'react-bootstrap';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import { FiHome } from 'react-icons/fi';
import { menusRota } from '../../utils/menus';
import { useUsuarioLogado } from '../../hooks/usuarioLogado';
import { IconButton } from '@mui/material';

export function MenuHeader() {

  const [show, setShow] = useState(false);
  const { usuario } = useUsuarioLogado();

  const ParceiroId = localStorage.getItem('@Gscon:ParceiroID')
  const ParceiroCor = localStorage.getItem('@Gscon:ParceiroCor')
  const ParceiroImagem = localStorage.getItem('@Gscon:ParceiroImagem')
  const ParceiroContrato = localStorage.getItem('@Gscon:ParceiroContrato')

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  function hasChild(father: number) {
    return usuario?.listMenuUsuario?.some((ichild: { menu: any }) =>
      menusRota.some(item =>
        item.menusInferiores.some(men => item.id === father && ichild.menu.id === men.id)
      )
    )
  }

  function renderChilds(idChild: number) {
    if (usuario !== undefined && usuario.listMenuUsuario !== undefined) {
      let array = usuario.listMenuUsuario.sort((a: any, b: any) => { return a.menu.nome < b.menu.nome ? -1 : a.menu.nome > b.menu.nome ? 1 : 0 });
      const idsRenderizados = new Set<number>();
      return array.map((ichild: { menu: any }) =>
        menusRota.map(item => {
          return item.menusInferiores.map((men: { id: any; nome: any; ordem?: number | undefined; rota: any; }) => {
            if (item.id === idChild && ichild.menu.id === men.id && !idsRenderizados.has(men.id)) {
              idsRenderizados.add(men.id)
              return renderMenu(men)
            }
          })
        }
        )
      )
    }
  }

  function renderMenu(menu: { id?: number; nome: any; ordem?: number; rota: any; }) {
    return <Link key={menu.id} style={{ textDecoration: 'none' }} to={menu.rota}>
      <ListGroup.Item>
        <p style={{ margin: '0 0 0 20px' }}>{menu.nome}</p>
      </ListGroup.Item>
    </Link>
  }

  return (
    <>
      <Container>
        <IconButton onClick={handleShow} className="botao" >
          <MenuIcon />
        </IconButton>
      </Container>

      <Offcanvas show={show} onHide={handleClose} style={{zIndex: 12000}}>
        <Offcanvas.Header closeButton closeVariant='white' style={{background:ParceiroCor||""}} >
          <Offcanvas.Title onClick={handleClose} style={{ color: '#ffffff' }} >Menu Gscon</Offcanvas.Title>
        </Offcanvas.Header >
        <Offcanvas.Body>
          <Accordion defaultActiveKey="0">
            <ListGroup variant="flush">
              <Link style={{ textDecoration: 'none' }} to="/">
                <ListGroup.Item style={{
                  background:ParceiroCor||"",
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                }}><FiHome color='#ffffff' />
                  <p style={{ margin: '0 20px', color: '#ffffff' }}>Home</p>
                </ListGroup.Item>
              </Link>
            </ListGroup>
            {hasChild(1) ?
              <Accordion.Item eventKey="0">
                <Accordion.Header>Usuários</Accordion.Header>
                <Accordion.Body style={{ padding: 0,background:ParceiroCor||""}}>
                  <ListGroup variant="flush" style={{background:ParceiroCor||""}}>
                    {renderChilds(1)}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
              : <></>
            }
            {hasChild(2) ?
              <Accordion.Item eventKey="1">
                <Accordion.Header>Configurações</Accordion.Header>
                <Accordion.Body style={{ padding: 0 }}>
                  <ListGroup>                   
                  {renderChilds(2)}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
              : <></>
            }
            {hasChild(3) ?
              <Accordion.Item eventKey="2">
                <Accordion.Header>Simulação</Accordion.Header>
                <Accordion.Body style={{ padding: 0 }}>
                  <ListGroup variant="flush">                    
                  {renderChilds(3)}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
              : <></>
            }

            {hasChild(4) ?
              <Accordion.Item eventKey="3">
                <Accordion.Header>Vendas</Accordion.Header>
                <Accordion.Body style={{ padding: 0 }}>
                  <ListGroup variant="flush">
                  {renderChilds(4)}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
              : <></>
            }
            {hasChild(26) ?
              <Accordion.Item eventKey="4">
                <Accordion.Header>Assembleia</Accordion.Header>
                <Accordion.Body style={{ padding: 0 }}>
                  <ListGroup variant="flush">
                  {renderChilds(26)}
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
              : <></>
            }
          </Accordion>

        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}